module.exports = __webpack_public_path__ + "static/media/Du-an-20.6498a0d4.svg";